import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

/**
 * Кнопка, умеющая отображать состояние загрузки формы
 */

@Component({
    selector: 'app-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <button [type]="type" class="{{className}}" [class.button--pending]="pending" [disabled]="disabled">
            <ng-container *ngIf="pending">
                <span class="button__overlay-icon"><lib-icon [size]="36" type="@animated/loading"></lib-icon></span>
            </ng-container>
            <ng-content></ng-content>
        </button>
    `
})

export class ButtonComponent {
    @Input() type: 'button'|'submit' = 'submit';
    @Input() className = 'button-green';
    @Input() disabled = false;

    /**
     * Идет загрузка?
     * @type {boolean}
     */
    @Input() pending = false;
}
